import { createReducer } from '@reduxjs/toolkit'
import { types } from 'actions/uploader_actions'

const initialState = {}

export default createReducer(initialState, (builder) => {
  builder
    .addCase(types.INIT, (state, action) => {
      state[action.buttonId] = {
        ...action.data,
        files: action.data.files || [],
        filesOptions: action.data.filesOptions || {}
      }
    })
    .addCase(types.INIT_ALBUMS, (state, action) => {
      Object.assign(state, action.uploaders)
    })
    .addCase(types.SET_UPLOADER_STATE, (state, action) => {
      if (state[action.buttonId]) {
        state[action.buttonId].state = action.state
      }
    })
    .addCase(types.ADD_NEW_FILES, (state, action) => {
      const { buttonId, files } = action
      if (!state[buttonId]) state[buttonId] = { files: [], filesOptions: {} }
      if (!state[buttonId].files) state[buttonId].files = []
      if (!state[buttonId].filesOptions) state[buttonId].filesOptions = {}

      const uploaderState = state[buttonId]

      const shouldPrepend = uploaderState.filesOptions?.prependNewFiles || false

      if (shouldPrepend) {
        // Set position = 1 for new files and increment existing files' positions
        const existingFiles = uploaderState.files
        existingFiles.forEach((file) => {
          if (file.position) {
            file.position += files.length
          }
        })

        files.forEach((file, index) => {
          file.position = index + 1
        })

        uploaderState.files = [...files, ...existingFiles]
      } else {
        uploaderState.files.push(...files)
      }
    })
    .addCase(types.UPDATE, (state, action) => {
      const { buttonId, id, data } = action
      const file = state[buttonId]?.files?.find((f) => f.id == id)
      if (file) {
        Object.assign(file, data, { _updated: true })
      }
    })
    .addCase(types.REORDER, (state, action) => {
      const { buttonId, ids } = action
      const files = state[buttonId]?.files
      if (!files) return

      // Update positions
      files.forEach((file) => {
        const position = ids.indexOf(file.id.toString()) + 1
        if (position > 0) {
          file.position = position
        }
      })

      // Sort by position
      state[buttonId].files = files.sort((a, b) => (a.position || 0) - (b.position || 0))
    })
    .addCase(types.UPDATE_FILE_DATA, (state, action) => {
      const { buttonId, data } = action
      const file = state[buttonId]?.files?.find((f) => f.id == data.id)
      if (file) {
        file.src = data.url
        file._new = true
      }
    })
    .addCase(types.AUTOSAVE_ATTACHMENTS, (state, action) => {
      const { buttonId, data } = action
      if (!state[buttonId]) state[buttonId] = {}
      state[buttonId].files = data.attachments
    })
    .addCase(types.MAKE_FAVORITE, (state, action) => {
      const { buttonId, id, favorite } = action
      const file = state[buttonId]?.files?.find((f) => f.id == id)
      if (file) {
        if (!file.favorite) file.favorite = {}
        file.favorite.enabled = favorite
      }
    })
    .addCase(types.REMOVE_FROM_STATE, (state, action) => {
      const { buttonId, id } = action
      const files = state[buttonId]?.files
      if (files) {
        const index = files.findIndex((f) => f.id == id)
        if (index !== -1) {
          files.splice(index, 1)
        }
      }
    })
    .addCase(types.DESTROY_ATTACHMENT, (state, action) => {
      const { buttonId, id } = action
      const files = state[buttonId]?.files
      if (files) {
        const index = files.findIndex((f) => f.id == id)
        if (index !== -1) {
          files.splice(index, 1)
        }
      }
    })
    .addCase(types.MARK_FOR_DESTROY, (state, action) => {
      const { buttonId, id } = action
      const file = state[buttonId]?.files?.find((f) => f.id == id)
      if (file) {
        file._destroy = true
      }
    })
    .addCase(types.UPDATE_ATTACHABLE, (state, action) => {
      const {
        sourceKey,
        targetKey,
        data: { moved_file_ids },
      } = action
      const sourceFiles = state[sourceKey]?.files || []
      const movedFiles = []

      // Remove from source and collect moved files
      state[sourceKey].files = sourceFiles.filter((file) => {
        if (moved_file_ids.includes(file.id)) {
          movedFiles.push({ ...file, selected: false })
          return false
        }
        return true
      })

      // Add to target
      if (!state[targetKey]) state[targetKey] = { files: [] }
      if (!state[targetKey].files) state[targetKey].files = []
      state[targetKey].files.push(...movedFiles)
    })
})
